import type { Command } from "../types.ts";

export const about: Command = {
  name: "about",
  aliases: ["bio", "me"],
  description: "Who I am.",
  run(ctx) {
    const p = ctx.term.profile;
    ctx.printHTML(`<span class="label">${e(p.role)} · ${e(p.location)}</span>`);
    ctx.print("");
    // Bio paragraphs are genuine prose, so they get the serif. Structured
    // output (/help, /skills) stays monospace — its alignment depends on it.
    for (const para of p.about) {
      ctx.print(para, "para");
      ctx.print("");
    }
    ctx.printHTML(
      `<span class="c-muted">next · <a class="link" href="#" data-run="/skills">/skills</a> ` +
        `<a class="link" href="#" data-run="/projects">/projects</a></span>`,
    );
  },
};

function e(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
